/**
 * Custom swatch: on click, update product card title, URL, image; show sizes and Add to cart.
 * Uses data-product, data-href, data-product-image, data-size-variants for fast switch.
 * Sold-out sizes are greyed out and not clickable. Add button uses theme's theme:cart:add flow.
 */
(function () { 
  function parseJsonAttr(el, attr) {
    try {
      var raw = el.getAttribute(attr);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  }

  function renderSizes(container, sizeVariants, selectedVariantId) {
    container.innerHTML = '';
    if (!sizeVariants || sizeVariants.length === 0) return;

    sizeVariants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-swatch__size' + (v.available ? '' : ' is-soldout');
      btn.textContent = v.name;
      btn.setAttribute('data-variant-id', v.id);
      if (!v.available) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.setAttribute('data-custom-swatch-size', '');
      }
      if (Number(v.id) === Number(selectedVariantId)) {
        btn.classList.add('is-active');
      }
      container.appendChild(btn);
    });
  }

  function handleCustomSwatchClick(e) {
    var btn = e.target.closest('[data-custom-swatch-button]');
    if (!btn) return;

    var card = btn.closest('.product-grid-item');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();

    var swatch = btn.closest('[data-custom-swatch]');
    var url = btn.getAttribute('data-href');
    var productData = parseJsonAttr(btn, 'data-product');
    var title = productData && productData.title ? productData.title : btn.getAttribute('title');
    var imageUrl = btn.getAttribute('data-product-image');
    var imageUrlHover = btn.getAttribute('data-product-image-hover');
    var sizeVariants = parseJsonAttr(btn, 'data-size-variants');

    var titleLink = card.querySelector('.product-grid-item__title');
    var mediaLink = card.querySelector('.product__media__holder');
    var priceLink = card.querySelector('.product-grid-item__price[href]');
    var priceEl = card.querySelector('.product-grid-item__price');
    var mediaFeatured = card.querySelector('[data-product-media-featured]');
    var mainImage = mediaFeatured
      ? mediaFeatured.querySelector('.product__media--featured-visible img') || mediaFeatured.querySelector('[data-main-image] img') || mediaFeatured.querySelector('img')
      : card.querySelector('.product__media--featured-visible img') || card.querySelector('[data-main-image] img') || card.querySelector('.product__media__image img');
    var hoverImage = card.querySelector('[data-product-image-hover] img') || card.querySelector('.product__media__hover-img img');

    if (url && titleLink) {
      titleLink.href = url;
      titleLink.setAttribute('aria-label', title);
      titleLink.textContent = title;
    }
    if (url && mediaLink) {
      mediaLink.href = url;
      mediaLink.setAttribute('aria-label', title);
    }
    if (url && priceLink) {
      priceLink.href = url;
    }
    if (productData && productData.price && priceEl) {
      var priceText = priceEl.querySelector('.price__current, .money');
      if (priceText) priceText.textContent = productData.price;
    }
    if (imageUrl && mainImage) {
      mainImage.src = imageUrl;
      mainImage.setAttribute('srcset', imageUrl + ' 800w');
      var picture = mainImage.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function (source) {
          source.srcset = imageUrl + ' 800w';
        });
      }
    }
    if (imageUrlHover && hoverImage) {
      hoverImage.src = imageUrlHover;
      hoverImage.setAttribute('srcset', imageUrlHover + ' 800w');
      var hoverPicture = hoverImage.closest('picture');
      if (hoverPicture) {
        hoverPicture.querySelectorAll('source').forEach(function (source) {
          source.srcset = imageUrlHover + ' 800w';
        });
      }
    } else if (imageUrl && hoverImage) {
      hoverImage.src = imageUrl;
      hoverImage.setAttribute('srcset', imageUrl + ' 800w');
    }

    card.querySelectorAll('.custom-swatch__item').forEach(function (item) {
      item.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    var panel = swatch && swatch.querySelector('[data-custom-swatch-panel]');
    var sizesEl = swatch && swatch.querySelector('[data-custom-swatch-sizes]');
    var form = swatch && swatch.querySelector('.custom-swatch__form');
    var variantInput = form && form.querySelector('[data-custom-swatch-variant-id]');
    var addBtn = form && form.querySelector('[data-custom-swatch-add]');

    if (!panel || !sizesEl || !form || !variantInput || !addBtn) return;

    openPanelForSwatchButton(swatch, btn);
  }

  function openPanelForSwatchButton(swatch, btn) {
    if (!swatch || !btn) return;
    var panel = swatch.querySelector('[data-custom-swatch-panel]');
    var sizesEl = swatch.querySelector('[data-custom-swatch-sizes]');
    var form = swatch.querySelector('.custom-swatch__form');
    var variantInput = form && form.querySelector('[data-custom-swatch-variant-id]');
    var addBtn = form && form.querySelector('[data-custom-swatch-add]');
    if (!panel || !sizesEl || !form || !variantInput || !addBtn) return;

    var sizeVariants = parseJsonAttr(btn, 'data-size-variants');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-visible');
    renderSizes(sizesEl, sizeVariants, null);

    if (sizeVariants && sizeVariants.length === 1) {
      variantInput.value = sizeVariants[0].id;
      addBtn.disabled = sizeVariants[0].available ? false : true;
    } else {
      variantInput.value = '';
      addBtn.disabled = true;
    }

    function onSizeClick(ev) {
      var sizeBtn = ev.target.closest('[data-custom-swatch-size]');
      if (!sizeBtn || sizeBtn.disabled) return;
      ev.preventDefault();
      ev.stopPropagation();
      var variantId = sizeBtn.getAttribute('data-variant-id');
      sizesEl.querySelectorAll('.custom-swatch__size').forEach(function (b) { b.classList.remove('is-active'); });
      sizeBtn.classList.add('is-active');
      variantInput.value = variantId;
      addBtn.disabled = false;
    }
    sizesEl.removeEventListener('click', onSizeClick);
    sizesEl.addEventListener('click', onSizeClick);
  }

  function initCustomSwatchDefaultPanel() {
    document.querySelectorAll('[data-custom-swatch]').forEach(function (swatch) {
      var panel = swatch.querySelector('[data-custom-swatch-panel]');
      if (!panel) return;
      var firstBtn = swatch.querySelector('.custom-swatch__item.is-active[data-custom-swatch-button]') || swatch.querySelector('[data-custom-swatch-button]');
      if (firstBtn) openPanelForSwatchButton(swatch, firstBtn);
    });
  }

  function initCustomSwatchDelegation() {
    document.removeEventListener('click', handleCustomSwatchClick, true);
    document.addEventListener('click', handleCustomSwatchClick, true);
  }

  function initProductPageSwatch() {
    document.querySelectorAll('[data-custom-swatch-product-page]').forEach(function (container) {
      var nameEl = container.querySelector('[data-custom-swatch-product-name]');
      var items = container.querySelectorAll('[data-custom-swatch-product-item]');
      if (!nameEl || !items.length) return;

      items.forEach(function (item) {
        var productName = item.getAttribute('data-product-name');
        if (!productName) return;

        item.addEventListener('mouseenter', function () {
          nameEl.textContent = productName;
        });
        item.addEventListener('focus', function () {
          nameEl.textContent = productName;
        });
      });

      container.addEventListener('mouseleave', function () {
        var active = container.querySelector('.custom-swatch-product-page__item.is-active');
        if (active) {
          var activeName = active.getAttribute('data-product-name');
          if (activeName) nameEl.textContent = activeName;
        }
      });
      container.addEventListener('blur', function (e) {
        if (!container.contains(e.relatedTarget)) {
          var active = container.querySelector('.custom-swatch-product-page__item.is-active');
          if (active) {
            var activeName = active.getAttribute('data-product-name');
            if (activeName) nameEl.textContent = activeName;
          }
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCustomSwatchDelegation();
      initCustomSwatchDefaultPanel();
      initProductPageSwatch();
    });
  } else {
    initCustomSwatchDelegation();
    initCustomSwatchDefaultPanel();
    initProductPageSwatch();
  }
})();
